import type { PreviewContext } from "../../patterns/previewContext";

/**
 * Extra context a feedback submission carries when sent from a testing preview
 * (quote-to-invoice-e2e-testing 08 §2), so a tester's report can be replayed:
 * which preview, what time the preview thought it was, and the order or quote in view.
 * Outside a testing preview there is nothing to add and the submission is unchanged.
 */
export function buildFeedbackContext(
  preview: PreviewContext | null,
  pagePath: string,
  previewNow: Date,
): Record<string, string> | undefined {
  if (!preview?.testing) return undefined;

  const context: Record<string, string> = {
    preview_time: previewNow.toISOString(),
  };
  if (preview.environmentId)
    context.preview_environment_id = preview.environmentId;

  const inView = documentInView(pagePath);
  if (inView) context[inView.kind] = inView.number;
  return context;
}

function documentInView(
  pagePath: string,
): { kind: "order_no" | "quote_no"; number: string } | null {
  const match = /^\/(orders|quotes)\/([^/]+)/.exec(pagePath);
  if (!match) return null;
  return {
    kind: match[1] === "orders" ? "order_no" : "quote_no",
    number: decodeURIComponent(match[2]),
  };
}
